// TODO: make this into a middleware?
import { SerializedError } from '@reduxjs/toolkit';
import { ShiftLogDetailError } from './networkUtils';
import { DdRum, ErrorSource, RumActionType } from '../logging/datadog';

export enum Event {
  OpenedPreferenceModal = 'opened_preference_modal',
  OpenedTemplateSelectionModal = 'opened_templates_selection_modal',
  SignInFailed = 'signin_failed',
  TokenRefreshFailed = 'token_refresh_failed',
  TokenRefreshInteractionRequired = 'token_refresh_interaction_required',
  AuthenticationError = 'authentication_error',
  SubmitShiftLog = 'submit_log',
  UpdateShiftLog = 'update_log',
  CancelShiftLogChanges = 'cancel_log_changes',
  AddRowToSnippet = 'add_row_to_snippet',
  RemoveRowFromSnippet = 'remove_row_from_snippet',
  ActivateStandingOrder = 'activate_standing_order_snippet',
  CompleteStandingOrder = 'complete_standing_order_snippet',
  PostStandingOrderComment = 'post_standing_order_comment',
  StartTask = 'start_task_snippet',
  PauseTask = 'pause_task_snippet',
  ResumeTask = 'resume_task_snippet',
  CompleteTask = 'complete_task_snippet',
  CancelTask = 'cancel_task_snippet',
  UpdateTaskCompletionPercentage = 'update_task_completion_percentage',
  PostTaskComment = 'post_task_comment',
}

export enum LogErrorType {
  Authentication = 'authentication_error',
  DonwloadReportLog = 'download_report_error',
  UpdateLog = 'update_log_error',
  TakeOverLog = 'take_over_log',
  FetchTakeOverDetails = 'take_over_log_details',
  SubmitLog = 'submit_log_error',
  CreateShiftLog = 'create_log_error',
  UnsubmitLog = 'unsubmit_log_error',
  RefreshShiftSummaries = 'refresh_shift_summaries_error',
  SavePreferences = 'update_preferences_error',
  RefreshPreferences = 'refresh_preferences_error',
  RefreshHierarchy = 'refresh_hierarchy_error',
  RefreshTemplates = 'refresh_templates_error',
  RefreshShiftLogs = 'refresh_shiftlogs_error',
  FetchShiftLogDetail = 'fetch_log_details_error',
  ActivateStandingOrder = 'activate_standing_order_snippet_error',
  CompleteStandingOrder = 'complete_standing_order_snippet_error',
  PostStandingOrderComment = 'post_standing_order_comment_error',
  StartTask = 'start_task_snippet_error',
  PauseTask = 'pause_task_snippet_error',
  ResumeTask = 'resume_task_snippet_error',
  CompleteTask = 'complete_task_snippet_error',
  CancelTask = 'cancel_task_snippet_error',
  UpdateTaskCompletionPercentage = 'update_task_completion_percentage_error',
  PostTaskComment = 'post_task_comment_error',
}

export const trackEvent = (name: Event, params?: { [key: string]: any }) => {
  if (__DEV__) {
    return;
  }

  DdRum.addAction(RumActionType.CUSTOM, name.toString(), params);
};

export const trackError = (error: Error | string, type: LogErrorType) => {
  if (__DEV__) {
    return;
  }

  let errorMessage: string;
  let stack: string;
  if (error instanceof Error) {
    errorMessage = error.message;
    stack = error.stack;
  } else {
    errorMessage = error;
  }
  DdRum.addError(errorMessage || 'unknown error', ErrorSource.SOURCE, stack || 'stack unavailable', {type: type});
};

export const trackShiftLogError = (error: ShiftLogDetailError, type: LogErrorType) => {
  if (__DEV__) {
    return;
  }

  const errorMessage = error && error.message

  trackError(errorMessage || 'unknown shift log error', type);
};

export const trackSerializedError = (error: SerializedError, type: LogErrorType) => {
  if (__DEV__) {
    return;
  }

  const errorMessage = error && error.message

  trackError(errorMessage || 'unknown serialized error', type);
};